import React, { useEffect } from "react";
import "react-multi-carousel/lib/styles.css";
import Aos from "aos";
import "aos/dist/aos.css";

export const Skills = () => {
  useEffect(() => {
    Aos.init();
  }, []);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div
            className="col-12"
            style={{ marginTop: "90px" }}
            data-aos="zoom-out-down"
          >
            <div className="skill-bx">
              <h2 style={{ padding: "20px" }}>Skills</h2>
              <div
                responsive={responsive}
                infinite={true}
                className="skill-slider"
              >
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/296"></iframe>
                  <h5>React</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/73748"></iframe>
                  <h5>JavaScrpit</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/72902"></iframe>
                  <h5>NodeJS</h5>
                </div>
                <div className="item">
                  <iframe src="https://lottie.host/?file=67c9ee8c-4095-45b9-9317-74f361e6ae79/Y93fuAX0Xw.json"></iframe>
                  <h5>HTML</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/63207"></iframe>
                  <h5>CSS</h5>
                </div>

                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/63210"></iframe>
                  <h5>MongoDB</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/85268"></iframe>
                  <h5>Git</h5>
                </div>
                <div className="item">
                  <iframe src="https://lottie.host/?file=16d41141-728b-41ac-beaa-8a11ebdb87fc/5C8f9ZLSKw.json"></iframe>
                  <h5>Github</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/296"></iframe>
                  <h5>React</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/73748"></iframe>
                  <h5>JavaScrpit</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/72902"></iframe>
                  <h5>NodeJS</h5>
                </div>
                <div className="item">
                  <iframe src="https://lottie.host/?file=67c9ee8c-4095-45b9-9317-74f361e6ae79/Y93fuAX0Xw.json"></iframe>
                  <h5>HTML</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/63207"></iframe>
                  <h5>CSS</h5>
                </div>

                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/63210"></iframe>
                  <h5>MongoDB</h5>
                </div>
                <div className="item">
                  <iframe src="https://embed.lottiefiles.com/animation/85268"></iframe>
                  <h5>Git</h5>
                </div>
                <div className="item">
                  <iframe src="https://lottie.host/?file=16d41141-728b-41ac-beaa-8a11ebdb87fc/5C8f9ZLSKw.json"></iframe>
                  <h5>Github</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
